/* eslint-disable max-len */
import 'react';

const Release = (
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="发布" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="编组">
                <rect id="矩形" x="0" y="0" width="12" height="12"></rect>
                <path d="M2.10236116,6.96762848 L1.60973922,6.70072643 C1.1290025,6.44026379 0.950435086,5.83940299 1.21089773,5.35866628 C1.30262104,5.18937228 1.4417213,5.05049961 1.61116528,4.95905366 L9.1091439,0.912525517 C9.59030649,0.652850464 10.1908741,0.832401596 10.4505491,1.31356419 C10.5483844,1.49484728 10.5872332,1.70213429 10.5616823,1.90654186 L9.62831168,9.37350655 C9.56049421,9.91604629 9.06570194,10.3008847 8.5231622,10.2330673 C8.40342165,10.2180997 8.28742641,10.1813667 8.18089732,10.1246801 L6.90169337,9.44398498 L6.90169337,9.44398498" id="路径-8" stroke="#FFFFFF" strokeWidth="1.25" strokeLinecap="round"></path>
                <path d="M7.2,4.95 C7.2,4.95 6.15,6.175 4.05,8.625 L4.05,11.25" id="路径-9" stroke="#FFFFFF" strokeWidth="1.25" strokeLinecap="round"></path>
            </g>
        </g>
    </svg>
);
export default Release;
